var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.033c-.375 0-.75-.141-1.033-.425l-5.725-5.725A4.699 4.699 0 0 1 1.875 7.35a4.622 4.622 0 0 1 1.708-3.392c1.834-1.516 4.65-1.325 6.409.434h.016c1.759-1.759 4.575-1.942 6.409-.434a4.665 4.665 0 0 1 1.708 3.392 4.699 4.699 0 0 1-1.367 3.533l-5.725 5.725a1.457 1.457 0 0 1-1.033.425ZM6.492 4.183c-.759 0-1.509.242-2.109.742a3.397 3.397 0 0 0-1.25 2.492 3.42 3.42 0 0 0 1 2.591l5.725 5.725a.201.201 0 0 0 .292 0l5.725-5.725a3.441 3.441 0 0 0-.25-5.083c-1.342-1.108-3.417-.958-4.725.35l-.45.45a.629.629 0 0 1-.883 0l-.45-.45A3.7 3.7 0 0 0 6.5 4.183h-.008Z",
    fill: "current"
  })));
};
export default SvgLike;